module.exports = {
    pathPrefix: "/",
    origin: "https://data.wdr.de",
}
